import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import FacebookLogin from '../../common/facebook-login';
import {
  resetPassword,
  verifyNewPassword,
  setPassword,
  SET_PASSWORD_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAIL,
  RESET_PASSWORD_FAIL
} from '../../redux/modules/auth';
import i18n from 'kodyl-js/i18n/react';
import LoadingSpinner from '../../common/loading-spinner';
import ErrorMessage from '../../common/error-message';

const RESETPASSWORD = 'resetPassword';
const SETPASSWORD = 'setPassword';

@connect(
  ({ auth: { user } }) => ({ user }),
  { verifyNewPassword, setPassword, resetPassword }
)
@i18n
class Reset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      status: false,
      error: false,
      verifyFail: false
    };
  }

  componentWillMount() {
    const {
      verifyNewPassword,
      location: { query },
      user
    } = this.props;
    if (!Object.keys(query).length || user) {
      return;
    }
    this.setState({ loading: true });
    return verifyNewPassword(query).then(action => {
      if (action.error) {
        // TODO: Change error - it would more likely be the token that is wrong?
        this.setState({
          verifyFail: this.i18n(
            'Beklager! Vi kunne ikke finde din bruger. Tjek at du har kopieret hele linket til din browsers adressefelt, eller kontakt kundeservice.'
          )
        });
      }
      this.setState({ loading: false });
      return action;
    });
  }

  handleSubmit = (event, fn) => {
    event.preventDefault();
    const { email, password, password2 } = this.refs;

    if (
      password &&
      password2 &&
      password.value &&
      password2.value &&
      password.value !== password2.value
    ) {
      return this.setState({
        error: this.i18n(
          'Øv! Adgangskoderne matcher ikke. Prøv venligst igen.'
        ),
        status: false
      });
    }

    this.setState({ loading: true, error: false });

    const data = email ? { email: email.value } : { password: password.value };
    this.props[fn](data).then(action => {
      if (
        action.type === SET_PASSWORD_FAIL ||
        action.type === RESET_PASSWORD_FAIL
      ) {
        this.setState({
          error: this.i18n(
            'An error occurred. Please try again or contact customer support.'
          ),
          loading: false,
          status: false
        });
        return action;
      }
      this.setState({
        loading: false,
        status:
          action.type === SET_PASSWORD_SUCCESS
            ? SET_PASSWORD_SUCCESS
            : action.type === RESET_PASSWORD_SUCCESS
            ? RESET_PASSWORD_SUCCESS
            : true
      });
      return action;
    });
  };

  render() {
    const { loading, status, error, verifyFail } = this.state;
    const { user } = this.props;

    if (loading) {
      return (
        <Grid>
          <LoadingSpinner />
        </Grid>
      );
    }
    if (verifyFail) {
      return (
        <Grid>
          <ErrorMessage text={verifyFail} />
        </Grid>
      );
    }

    return (
      <Grid>
        <h2>
          {!user ? this.i18n('Reset password') : this.i18n('Change Password')}
        </h2>
        <Row>
          <hr />
          <Col sm={8}>
            {!user ? (
              <form
                onSubmit={event => this.handleSubmit(event, RESETPASSWORD)}
                name="form"
                autoComplete="on"
              >
                <div className="form-section">
                  <Row className="form-group">
                    <label htmlFor="email" className="col-sm-4 control-label">
                      {this.i18n('Email address')}
                      <abbr title={this.i18n('Required')}>*</abbr>
                    </label>
                    <Col sm={8}>
                      <input
                        type="email"
                        ref="email"
                        className="form-control"
                        name="email"
                        placeholder={this.i18n('Email address')}
                        required
                      />
                    </Col>
                  </Row>

                  <Row className="form-group">
                    <div className="col-sm-offset-4 col-sm-8">
                      <button
                        disabled={loading}
                        type="submit"
                        className="btn btn-primary"
                      >
                        <i
                          className="fa fa-unlock"
                          style={{
                            marginRight: '0.5em',
                            width: '1.28571429em',
                            textAlign: 'center'
                          }}
                        />
                        {this.i18n('Reset password')}
                      </button>{' '}
                      &nbsp;&nbsp;
                      <Link to="/login" className="btn">
                        {this.i18n('Go back to login')}
                      </Link>
                    </div>
                  </Row>
                </div>
              </form>
            ) : (
              <form
                onSubmit={event => this.handleSubmit(event, SETPASSWORD)}
                autoComplete="on"
              >
                <div className="form-section">
                  <Row className="form-group">
                    <label
                      htmlFor="password"
                      className="col-sm-4 control-label"
                    >
                      {this.i18n('New Password')}
                      <abbr title="Skal udfyldes">*</abbr>
                    </label>
                    <Col sm={8}>
                      <input
                        type="password"
                        ref="password"
                        className="form-control"
                        name="password"
                        placeholder={this.i18n('Your password')}
                        required="required"
                      />
                    </Col>
                    <br />
                    <br />
                    <label
                      htmlFor="password2"
                      className="col-sm-4 control-label"
                    >
                      {this.i18n('Password (again)')}
                      <abbr title="Skal udfyldes">*</abbr>
                    </label>
                    <Col sm={8}>
                      <input
                        type="password"
                        ref="password2"
                        className="form-control"
                        name="password2"
                        placeholder={this.i18n('Password (again)')}
                        required="required"
                      />
                    </Col>
                  </Row>
                  <Row className="form-group">
                    <div className="col-sm-offset-4 col-sm-8 text-right">
                      <button
                        type="submit"
                        disabled={loading}
                        className="btn btn-success"
                      >
                        <i className="fa fa-unlock" />
                        {this.i18n('Change Password')}
                      </button>
                    </div>
                  </Row>
                </div>
              </form>
            )}
            {status ? (
              <div className="alert alert-info" role="alert">
                {status === RESET_PASSWORD_SUCCESS
                  ? this.i18n(
                      'An email with instructions on how to reset your password has been sent to your email address.'
                    )
                  : this.i18n('Your password has been changed.')}
              </div>
            ) : null}
            {error ? <ErrorMessage text={error} /> : null}
          </Col>
          {!user ? (
            <Col sm={4}>
              <h4 style={{ marginTop: 0 }}>{this.i18n('No user yet?')}</h4>
              <Link to="/signup">
                <button type="submit" className="btn btn-primary">
                  <i
                    className="fa fa-user"
                    style={{
                      marginRight: '0.5em',
                      width: '1.28571429em',
                      textAlign: 'center'
                    }}
                  />
                  {this.i18n('Create profile')}
                </button>
              </Link>
              <hr />
              <FacebookLogin />
            </Col>
          ) : null}
        </Row>
      </Grid>
    );
  }
}

export default Reset;
